(function () {
  'use strict';

  angular.module('ringbaPortal').component('addAffiliate', {
    bindings: {
      currentCampaign: '<',
      offer: '<',
      campaignCountry: '<',
      onUpdate: '&',
      filter: '<',
      isRtbEnabled: '<',
      passThroughBid: '<',
    },
    controller: AddAffiliateController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/add-affiliate/add-affiliate.view.html'
  });

  function AddAffiliateController(
    $filter,
    $scope,
    $timeout,
    $translate,
    $uibModal,
    accountsService,
    bulkTagsService,
    campaignAffiliateService,
    accountSettingsService,
    featureFlags,
    isMobileDevice,
    numberService,
    offersService,
    tagService,
    toaster,
    utils,
    utilities,
    VuexStore
  ) {
    'ngInject';

    const vm = this;

    const render = utilities.safeApply.bind($scope);

    let affiliatePayoutShownId,
      affiliateNumberShownId;

    vm.inlineNumbersItemsLimit = 4;
    vm.inlinePayoutsItemsLimit = 3;
    vm.filter = 'All';

    vm.$onInit = onInit;
    vm.$onDestroy = onDestroy;
    vm.$onChanges = onChanges;
    vm.showForm = showForm;
    vm.hideForm = hideForm;
    vm.showPayoutSettings = showPayoutSettings;
    vm.hidePayoutSettings = hidePayoutSettings;
    vm.onCreate = onCreate;
    vm.onUpdateAffiliate = onUpdateAffiliate;
    vm.onPayoutSettingSave = onPayoutSettingSave;
    vm.onNewAffiliatePayoutOverrideClose = onNewAffiliatePayoutOverrideClose;
    vm.activateAffiliateActions = activateAffiliateActions;
    vm.removeAffiliateNumber = removeAffiliateNumber;
    vm.deleteAffiliate = deleteAffiliate;
    vm.showNumberForm = showNumberForm;
    vm.openDynamicInboundCallsDocumentationModal = openDynamicInboundCallsDocumentationModal;
    vm.closeDynamicInboundCallsDocumentationModal = closeDynamicInboundCallsDocumentationModal;
    vm.hideNumberForm = hideNumberForm;
    vm.showPayouts = showPayouts;
    vm.confirmNumberDeleteModal = confirmNumberDeleteModal;
    vm.confirmAffiliateDeleteModal = confirmAffiliateDeleteModal;
    vm.scrollToCampaignPayoutWidget = scrollToCampaignPayoutWidget;
    vm.onSaveAffiliatePayouts = onSaveAffiliatePayouts;
    vm.onEnrichmentURLCopied = onEnrichmentURLCopied;
    vm.onPhoneNumberCopied = onPhoneNumberCopied;
    vm.onRtbURLCopied = onRtbURLCopied;
    vm.cancelModal = cancelModal;
    vm.saveRtbOverride = saveRtbOverride;
    vm.setCampaignSettingsOverrideWithoutNotification = setCampaignSettingsOverrideWithoutNotification;

    function onInit() {
      vm.isMobileView = isMobileDevice;
      vm.pubOfferParticipationMap = {};
      vm.publisherFilterMap = campaignAffiliateService.publisherFilterMap;
      vm.filterOptions = Object.keys(vm.publisherFilterMap);
      utilities.ngVueEventBus.$on(utilities.ngVueEvents.EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED, _renderCampaignSettingsOverrideUpdated);
      accountSettingsService.loadSettings(accountsService.currentAccountId)
        .then(function (response) {
          vm.exposeCallerId = response.data.accountSettings.requirePubsToExposeCallerId;
        });
    }

    function onDestroy() {
      utilities.ngVueEventBus.$off(utilities.ngVueEvents.EVENT_CAMPAIGNS_SETTINGS_OVERRIDE_UPDATED, _renderCampaignSettingsOverrideUpdated);
    }

    function onChanges(changesObj) {
      if (changesObj.currentCampaign && vm.currentCampaign) {
        if (vm.currentCampaign.id
          && (!changesObj.currentCampaign.previousValue
            || changesObj.currentCampaign.previousValue.id !== changesObj.currentCampaign.currentValue.id)) {
          _getTags(vm.currentCampaign.id);
        }

        _getBulkTags();

        // this is a dirty hack to fix the issue where the classes added by ng-class-odd and ng-class-even
        // don't work as expected
        // This will run the $digest cycle again to make sure it gets the classes right everytime
        if(vm.currentCampaign && vm.currentCampaign.affiliates) {
          _fillRtbInfo(vm.currentCampaign.affiliates);

          $timeout(function () {
            _loadAffiliateData(affiliatePayoutShownId, affiliateNumberShownId);
          }, 0);
        }
      }

      if (changesObj.isRtbEnabled && changesObj.isRtbEnabled.currentValue && vm.currentCampaign && vm.currentCampaign.affiliates) {
        VuexStore.dispatch('dynamicInboundCalls/pullRTBAllPubSettings', { campaignId: vm.currentCampaign.id });
      }

      if (changesObj.offer) {
        vm.publishedOfferEnabled = vm.offer && vm.offer.offerState === 'enabled';
      }
    }

    function showForm(offerInvite) {
      if (!vm.formActive) {
        vm.showAddNewForm = true;
        vm.offerInvite = offerInvite;
        vm.activeActionAffiliateId = false;
        vm.formActive = true;
      }
    }

    function hideForm() {
      vm.showAddNewForm = false;
      vm.offerInvite = false;
      vm.formActive = false;
    }

    function showNumberForm(affiliate) {
      if (!vm.formActive) {
        affiliateNumberShownId = affiliate.id;
        vm.activeActionAffiliateId = false;
        vm.formActive = true;
        affiliate.showNumberForm = true;
      }
    }

    function hideNumberForm(affiliate) {
      vm.formActive = false;
      affiliateNumberShownId = undefined;
      delete affiliate.showNumberForm;
    }

    function openDynamicInboundCallsDocumentationModal(affiliate) {
      if (!vm.formActive) {
        affiliate.showDynamicInboundCallsDocumentationModal = true;
      }
    }

    function closeDynamicInboundCallsDocumentationModal(affiliate) {
      affiliate.showDynamicInboundCallsDocumentationModal = false;
    }

    function showPayoutSettings(affiliate) {
      if (!vm.formActive) {
        vm.formActive = true;
        affiliatePayoutShownId = affiliate.id;
        affiliate.showPayoutSettings = true;
        vm.activeActionAffiliateId = false;
      }
    }

    function hidePayoutSettings(affiliate) {
      vm.formActive = false;
      affiliatePayoutShownId = undefined;
      delete affiliate.showPayoutSettings;
    }

    function onCreate(affiliate) {
      vm.isPayoutOverriddenNewAffiliate = false;
      // hide the add publisher form
      hideForm();
      // affiliate is null if invited to offer
      if (affiliate) {
        if (featureFlags.isOn('rtb') && vm.isRtbEnabled) {
          VuexStore.dispatch('dynamicInboundCalls/pushDynamicInboundCallsPublisherSettings', { campaignId: vm.currentCampaign.id, affiliateId: affiliate.id, newAffiliate: true })
            .catch(function (error) {
              utilities.errorHandler(error);
            });
        }
        vm.newAffiliateAdded = [affiliate];
        showPayoutSettings(affiliate);
      }

      // Reload campaign to have the newly added affiliate in the list already.
      // This will avoid the lag when user closes the payout settings panel and immediately see the new publisher row
      // but this will be hidden initially
      vm.onUpdate();
    }

    // Used for number form only
    function onUpdateAffiliate(affiliate) {
      hideNumberForm(affiliate);
      vm.onUpdate();
    }

    // This is used as a callback to newly added payout settings panel, onSave -> affiliatePayouts
    function onPayoutSettingSave(affiliate) {
      vm.isPayoutOverriddenNewAffiliate = true;

      // This sets the payout settings in the newly added affiliate object
      // We could've set campaign payouts to the affiliate (since it's a newly added affiliate) but for old campaigns where we're storing affiliates with no numbers,
      // they might have overridden payouts.
      campaignAffiliateService.setPayoutSettings(accountsService.currentAccountId, vm.currentCampaign, affiliate).then(function() {

        // this is to avoid flicker when we close the newly added payout settings panel
        // and user has overridden the publisher payout override.
        _updatePayoutInCampaignAffiliatesList(affiliate, vm.affiliateNumbers);
        onNewAffiliatePayoutOverrideClose(affiliate);
      });
    }

    function onNewAffiliatePayoutOverrideClose(affiliate) {
      hidePayoutSettings(affiliate);
      vm.newAffiliateAdded = [];
      _markRowToBeHidden(affiliate.id, vm.affiliateNumbers, false);
      vm.onUpdate();
    }

    function onSaveAffiliatePayouts(affiliate) {
      vm.onUpdate();
      hidePayoutSettings(affiliate);
    }

    function activateAffiliateActions(affiliateId) {
      if (!vm.formActive) {
        vm.activeActionAffiliateId = vm.activeActionAffiliateId == affiliateId ? false : affiliateId;
      }
    }

    function confirmNumberDeleteModal(number, affiliate) {
      if (!vm.formActive) {
        return removeAffiliateNumber(number, affiliate);
      }
    }

    function removeAffiliateNumber(number, affiliate) {
      // Removing number from affiliate also removes it from a campaign, and since all campaign numbers belong to affiliates, it is ok to call this method
      return numberService.removeAffiliate(accountsService.currentAccountId, number.numberId, affiliate.id).then(function () {
        toaster.pop('success', $filter('translate')('PUBLISHERS_NUMBERS_REMOVE_CAMPAIGN'));
        vm.onUpdate();
      }).catch(utils.errorHandler);
    }

    function confirmAffiliateDeleteModal(affiliate) {
      if (!vm.formActive) {
        vm.affiliateToRemove = affiliate;
        vm.modal = $uibModal.open({
          templateUrl: '/scripts/shared/components/add-affiliate/remove-affiliate-confirmation.modal.html',
          scope: $scope,
          controllerAs: 'vm'
        });
      }
    }

    function deleteAffiliate(affiliate) {
      // This deletes all numbers associated with the affiliate and removes affiliate from campaign
      return campaignAffiliateService.deleteAffiliate(accountsService.currentAccountId, vm.currentCampaign.id, affiliate.id)
        .then(function () {
          toaster.pop('success', $filter('translate')('PUBLISHERS_NUMBERS_BATCH_REMOVE_CAMPAIGN'));
          cancelModal();
          vm.onUpdate();
        })
        .catch(utils.errorHandler);
    }

    function showPayouts(affiliate) {
      if(!vm.formActive && affiliate.payoutsOverridden) {
        showPayoutSettings(affiliate);
      } else if(!affiliate.payoutsOverridden) {
        scrollToCampaignPayoutWidget();
      }
    }

    function scrollToCampaignPayoutWidget() {
      utils.scrollToElementId('panel-payout-settings', 60);
    }

    function onEnrichmentURLCopied() {
      toaster.pop('success', $translate.instant('COPIED_AFFILIATE_INBOUND_DATA_URL'));
    }
    function onPhoneNumberCopied() {
      toaster.pop('success', $translate.instant('COPIED_PHONE_NUMBER'));
    }

    function onRtbURLCopied() {
      toaster.pop('success', $translate.instant('COPIED_RTB_URL'));
    }

    function cancelModal() {
      if (vm.modal) {
        vm.modal.close();
        vm.modal = null;
        vm.affiliateToRemove = null;
      }
    }

    function saveRtbOverride(affiliateId) {
      return VuexStore.dispatch('dynamicInboundCalls/pushDynamicInboundCallsPublisherSettings', { campaignId: vm.currentCampaign.id, affiliateId: affiliateId })
        .then(function () {
          toaster.pop('success', 'Successfully updated publisher RTB settings');
        })
        .catch(function (error) {
          utilities.errorHandler(error);
        });
    }

    function setCampaignSettingsOverrideWithoutNotification(affiliateId, val) {
      return VuexStore.dispatch('dynamicInboundCalls/setCampaignSettingsOverrideWithoutNotification', { campaignId: vm.currentCampaign.id, affiliateId: affiliateId, val:val });
    }

    function _getBulkTags() {
      bulkTagsService.getBulkTags(accountsService.currentAccountId).then(function (response) {
        vm.uploadedBulkTags = response.data.bulkTagUploads;
      });
    }

    function _loadAffiliateData(affiliatePayoutShownId, affiliateNumberShownId) {
      const affiliateNumbers = _loadAffiliateNumbers(affiliatePayoutShownId, affiliateNumberShownId);
      _loadOfferParticipants(affiliateNumbers).then(function (modifiedAffiliateNumbers) {
        vm.affiliateNumbers = modifiedAffiliateNumbers;
      }).catch(function () {
        vm.affiliateNumbers = affiliateNumbers;
      });
    }

    function _loadAffiliateNumbers(showPayoutOfAffiliateId, showNumberOfAffiliateId) {
      const tempAffiliateNumbers = campaignAffiliateService.setAffiliateNumbersList(accountsService.currentAccountId, vm.currentCampaign, vm.currentCampaign.affiliates, vm.currentCampaign.affiliateNumbers);

      // Hide newly added publisher row when the new publisher's payout settings is being edited
      if(vm.newAffiliateAdded && vm.newAffiliateAdded.length) {
        _markRowToBeHidden(vm.newAffiliateAdded[0].id, tempAffiliateNumbers, true);
      } else if (showPayoutOfAffiliateId) {
        // Show payout form of affiliate which is already open
        _setShowFormProperty(showPayoutOfAffiliateId, tempAffiliateNumbers, 'showPayoutSettings');
      } else if(showNumberOfAffiliateId) {
        // Show number form of affiliate which is already open
        _setShowFormProperty(showNumberOfAffiliateId, tempAffiliateNumbers, 'showNumberForm');
      }

      return tempAffiliateNumbers;
    }

    function _setShowFormProperty(affiliateId, affiliateNumbers, property) {
      const payoutOfAffiliateShown = _.find(affiliateNumbers, { id: affiliateId });
      if(payoutOfAffiliateShown) {
        payoutOfAffiliateShown[property] = true;
      }
    }

    function _markRowToBeHidden(affiliateId, affiliateNumbers, hide) {
      const payoutOfAffiliateShown = _.find(affiliateNumbers, { id: affiliateId });
      if (payoutOfAffiliateShown) {
        payoutOfAffiliateShown.hideRow = hide;
      }
    }

    function _updatePayoutInCampaignAffiliatesList(affiliate, affiliateNumbers) {
      const campaignAffiliate = _.find(affiliateNumbers, { id: affiliate.id });
      if(campaignAffiliate) {
        campaignAffiliate.payoutSettingsList = affiliate.payoutSettingsList;
        campaignAffiliate.payoutsOverridden = affiliate.payoutsOverridden;
      }
    }

    function _getTags(campaignId) {
      tagService.getTagsByCampaign(accountsService.currentAccountId, campaignId).then(function (response) {
        vm.availableTags = response.data;
      });
    }

    function _loadOfferParticipants(affiliateNumbers) {
      return offersService.getOfferParticipants(accountsService.currentAccountId, vm.currentCampaign.id).then(
        function (response) {
          const data = response.data;

          vm.pubOfferParticipationMap = data.isSuccessful ? _.keyBy(data.participationRecords, 'publisherId') : {};

          _.forEach(affiliateNumbers, function(p) {
            const participation = vm.pubOfferParticipationMap[p.id];
            // TODO: Update this to be the offer participation status after pub view is merged.
            p.offerPub = participation != null && participation.offerParticipationStatus == 'enrolled';
          });
        }
      ).then(function () {
        return affiliateNumbers;
      });
    }

    function _renderCampaignSettingsOverrideUpdated(affiliate) {
      if(vm.currentCampaign && vm.currentCampaign.affiliates) {
        _fillRtbInfo(vm.currentCampaign.affiliates.filter(function (af) { return af.id === affiliate.affiliateId; }));
        $timeout(function () {
          _loadAffiliateData(affiliatePayoutShownId, affiliateNumberShownId);
        }, 0);
      }

      render();
    }

    function _fillRtbInfo(affiliates) {
      if (featureFlags.isOn('rtb') && vm.isRtbEnabled) {
        affiliates.forEach(function(af) {
          if (!af.rtbId) {
            af.rtbId = VuexStore.getters['dynamicInboundCalls/rtbId'](vm.currentCampaign.id, af.id);
          }

          af.campaignSettingsOverride = VuexStore.getters['dynamicInboundCalls/campaignSettingsOverride'](vm.currentCampaign.id, af.id);

          af.isRtbEnabled = VuexStore.getters['dynamicInboundCalls/enabled'](vm.currentCampaign.id, af.id);
          af.callerIdRequiredOverride = VuexStore.getters['dynamicInboundCalls/callerIdRequired'](vm.currentCampaign.id, af.id);

          af.rateLimitOverride = VuexStore.getters['dynamicInboundCalls/rateLimitOverride'](vm.currentCampaign.id, af.id);
          af.bidSettingsOverride = VuexStore.getters['dynamicInboundCalls/bidSettingsOverride'](vm.currentCampaign.id, af.id);
          af.passThroughBidOverride = VuexStore.getters['dynamicInboundCalls/passThroughBidOverride'](vm.currentCampaign.id, af.id);
          af.bidAdjustmentsOverride = VuexStore.getters['dynamicInboundCalls/bidAdjustmentsOverride'](vm.currentCampaign.id, af.id);
          af.minDurationAdjustmentsOverride = VuexStore.getters['dynamicInboundCalls/minDurationAdjustmentsOverride'](vm.currentCampaign.id, af.id);
        });
      }
    }
  }
})();
